import { Injectable, Input } from '@angular/core';
import { ExtendedOrganizationModel } from '../../models/organization.model';
import { UserSessionService } from '../user-session/user-session.service';

@Injectable({
  providedIn: 'root'
})
export class ClinicAccessService {
  @Input() organization: ExtendedOrganizationModel;

  locationNumber:string;
  locationNumbers:any;
  locationType:string;
  clinicPrimaryStore:number;
  storeDistricts:any;
  userRole:string;
  isStoreUser:boolean = false;
  isDistrictManager:boolean = false;
  isOrgAdmin:boolean = true;

  constructor(
    private session: UserSessionService,
  ) {

    this.locationNumber = this.session.sessionAccount?.locationNumber;
    this.locationNumbers = this.session.sessionAccount?.locationNumbers;
    this.userRole = this.session.sessionAccount?.privilege.name;
    this.clinicPrimaryStore = this.organization?.primaryStore;
    this.locationType = this.session.sessionAccount?.locationType;
    this.storeDistricts = this.organization?.storeDistricts;


    if(this.locationNumber)
      if (!session.getSession().walgreenGroup.includes("COVID_ACTIVATION_TEAM")) {
        this.isOrgAdmin = false;
      }
    if(this.locationType && this.locationType == 'DISTRICT'){
      this.locationNumbers?.forEach((locNum) => {
        this.storeDistricts?.forEach((dist) => {
          if(locNum == dist){
            this.isDistrictManager = true;
          }
        });
      });
    }

    this.locationNumbers?.forEach((item) =>{
      if(item == this.clinicPrimaryStore){
        this.isStoreUser = true;
      }
    });

  }

  getAccess():boolean{
    if( this.userRole =='Super Admin' || this.isStoreUser || this.isDistrictManager || this.isOrgAdmin){
      return true;
    }else{
      return false;
    }
  }
  getClinicCreateAccess():boolean{
    if(this.isOrgAdmin){
      return true;
    }else{
      return false;
    }
  }

}
